import { fromSeconds, fromHours } from '@resn/gozer-misc';
import { isMobile } from '@resn/gozer-env';

export const SIZES = {
    MOBILE_THRESHOLD: 850,
    // MOBILE_THRESHOLD: 750,
};

export const LAYERS = {
    BACKGROUND: 0,
    SCENE: 1,
    UI: 2,
};

export const LINKS = {
    OXEFIT_EXPERIENCE: 'https://experience.oxefit.com/',
};

export const DIR = {
    IMG: `${__CDN__}static/images/`,
    VIDEO: `${__CDN__}static/video/`,
};

export const COLORS = {
    YELLOW: '#E0E800',
    PINK: '#ff069a',
    DARK_BLUE: '#0A1221',
    DARK_BLUE_20: '#0a122140',
    BLUE: '#0A1A3B',
    LIGHT_BLUE: '#3265fa',
    LIGHT_BLUE_2: '#82D4FF',
    HIGHLIGHT_BLUE: '#82D4FF',
    ELECTRIC_BLUE: '#3265fa',
    OXE_BLUE: '#5294FF',
    VIOLET: '#87189D',
    ORANGE: '#d93600',
    OXE_ORANGE: '#F8441D',
    TRANSPARENT: 'transparent',

    WHITE: '#ffffff',
    OFF_WHITE: '#ECECEA',
    BLACK: '#000000',
    BLACK_TRANSPARENT: 'rgba(0, 0, 0, 0.5)',
    GREY: '#DEDFE3',
    // new colors
    AQUA: '#47D7AC',
    CITRON: '#feff76',
};

export const TIME = {
    COUNTDOWN_START: fromHours(24),
    COUNTDOWN_2_HOURS: fromHours(2),
    COUNTDOWN_FINAL: fromSeconds(60),
    SHOP_LIVE: fromSeconds(197 + 6),
    QA_START: fromSeconds(206 + 6),
    QA_END: fromSeconds(547 + 6),
    END_SEQ: fromSeconds(453 + 6),
    EVENT_DUR: fromSeconds(547 + 6),
};

export const MENU_TIMESCALE = isMobile ? 1.3 : 1.1;
export const INTERACTION_THROTTLE = 5000;
export const EMAIL_REGEX = () =>
    RegExp(
        // eslint-disable-next-line max-len
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
// Turn sales promo functionality on or off
export const SALES_INCENTIVE_ENABLED = true;
// Complementary month codes
export const COMP_MONTH_CODES = {
    X9T4GQ: 1,
    B7Z1YD: 2,
    M3L8VN: 3,
};
export const MENA_VIEW = 'X9TR8V2L';

export const COMMERCIAL_ENABLED_UAE = true;
